import { ClientTypeEnum } from "@dune/types";
import { Button, Card, Input } from "@dune/ui";
import { ClientDetailsWithRelations, RoleEnum } from "@dune/vars";
import React from "react";
import { useMe } from "../../../api/queries/users.queries";
import { isSocietySyndic } from "@dune/utils";

interface GeneralTabProps {
	client: ClientDetailsWithRelations;
	setIsEditDialogOpen?: (isOpen: boolean) => void;
}

const GeneralTab: React.FC<GeneralTabProps> = ({
	client,
	setIsEditDialogOpen,
}) => {
	const { me: user } = useMe();
	const canEdit =
		user?.role === RoleEnum.DUNE || user?.role === RoleEnum.BROKER;
	if (client.clientType === ClientTypeEnum.USER) {
		const contact =
			client.constructionSiteClientContacts[0]?.constructionSiteContact;
		return (
			<div className="flex flex-col gap-6 p-6">
				<div className="flex justify-between items-start">
					<div className="text-xl font-semibold text-text-blue">
						Informations client
					</div>
					{setIsEditDialogOpen && canEdit && (
						<Button
							type="button"
							variant="outline"
							onClick={() => setIsEditDialogOpen(true)}
							className="border-upload-button border-2 text-upload-button font-bold"
						>
							Modifier les informations
						</Button>
					)}
				</div>
				<Card className="p-6">
					<div className="grid grid-cols-2 gap-4">
						<Input
							label="Nom"
							value={contact?.lastname || ""}
							disabled
							className="bg-gray-50"
						/>
						<Input
							label="Prénom"
							value={contact?.firstname || ""}
							disabled
							className="bg-gray-50"
						/>
					</div>

					<div className="grid grid-cols-2 gap-4 mt-4">
						<Input
							label="Email"
							value={contact?.email || ""}
							disabled
							className="bg-gray-50"
						/>
						<Input
							label="Mobile"
							value={contact?.mobilePhone || ""}
							disabled
							className="bg-gray-50"
						/>
					</div>

					<div className="grid grid-cols-1 gap-4 mt-4">
						<Input
							label="Adresse"
							value={
								contact?.address
									? `${contact.address.streetNumber || ""} ${contact.address.streetName || ""}, ${contact.address.postalCode || ""} ${contact.address.city || ""}`.trim()
									: ""
							}
							disabled
							className="bg-gray-50"
						/>
					</div>
				</Card>
			</div>
		);
	}

	const society = client.clientSociety;
	const contactInfo = society?.syndicUserAccessToPlatform;

	return (
		<div className="flex flex-col gap-6 p-6">
			<div className="grid grid-cols-2 gap-8">
				<div className="flex flex-col gap-4">
					<div className="flex justify-between items-center">
						<div className="text-xl font-semibold text-text-blue mb-2">
							{client.clientSociety && isSocietySyndic(client.clientSociety)
								? "Informations syndic"
								: "Informations société"}
						</div>
					</div>

					<Card className="p-6">
						{client.clientSociety && isSocietySyndic(client.clientSociety) && (
							<div className="flex items-center gap-2 mb-4">
								<input type="checkbox" checked readOnly className="rounded" />
								<span className="text-sm">
									Il s'agit d'un syndic de copropriété
								</span>
							</div>
						)}

						<div className="grid grid-cols-1 gap-4">
							<Input
								label="SIREN"
								value={society?.siren ?? ""}
								disabled
								className="bg-gray-50"
							/>

							<Input
								label="Dénomination"
								value={society?.denomination || ""}
								disabled
								className="bg-gray-50"
							/>

							<Input
								label="Adresse du siège social"
								value={
									society?.headOfficeAddress
										? `${society.headOfficeAddress.streetNumber || ""} ${society.headOfficeAddress.streetName || ""}, ${society.headOfficeAddress.postalCode || ""} ${society.headOfficeAddress.city || ""}`.trim()
										: ""
								}
								disabled
								className="bg-gray-50"
							/>
						</div>
					</Card>
				</div>

				<div className="flex flex-col gap-4">
					<div className="flex justify-between items-center">
						<div className="text-xl font-semibold text-text-blue">
							Informations contact
						</div>
						{setIsEditDialogOpen && canEdit && (
							<Button
								type="button"
								variant="outline"
								onClick={() => setIsEditDialogOpen(true)}
								className="border-upload-button border-2 text-upload-button font-bold"
							>
								Modifier les informations
							</Button>
						)}
					</div>

					<Card className="p-6">
						<div className="grid grid-cols-2 gap-4">
							<Input
								label="Nom"
								value={contactInfo?.lastname || ""}
								disabled
								className="bg-gray-50"
							/>
							<Input
								label="Prénom"
								value={contactInfo?.firstname || ""}
								disabled
								className="bg-gray-50"
							/>
						</div>

						<div className="grid grid-cols-2 gap-4 mt-4">
							<Input
								label="Email"
								value={contactInfo?.email || ""}
								disabled
								className="bg-gray-50"
							/>
							<Input
								label="Mobile"
								value={contactInfo?.mobilePhone || ""}
								disabled
								className="bg-gray-50"
							/>
						</div>

						<div className="grid grid-cols-1 gap-4 mt-4">
							<Input
								label="Adresse"
								value={
									contactInfo?.address
										? `${contactInfo.address.streetNumber || ""} ${contactInfo.address.streetName || ""}, ${contactInfo.address.postalCode || ""} ${contactInfo.address.city || ""}`.trim()
										: ""
								}
								disabled
								className="bg-gray-50"
							/>
						</div>
					</Card>
				</div>
			</div>
		</div>
	);
};

export default GeneralTab;
